export const FolderSolid = ({
  size = "24",
  ...props
}: {
  size?: string;
} & React.SVGProps<SVGSVGElement>) => (
  <>
    <span className="t-sr-only">Folder</span>
    <svg
      {...props}
      width={size}
      height={size}
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27 16.875H45.5625C46.0101 16.875 46.4393 17.0528 46.7557 17.3693C47.0722 17.6857 47.25 18.1149 47.25 18.5625V42.1875C47.25 42.6351 47.0722 43.0643 46.7557 43.3807C46.4393 43.6972 46.0101 43.875 45.5625 43.875H8.4375C7.98995 43.875 7.56073 43.6972 7.24426 43.3807C6.92779 43.0643 6.75 42.6351 6.75 42.1875V21.9375"
        fill="#FFC400"
      />
      <path
        d="M19.6805 21.9375H6.75V13.5C6.75 13.0524 6.92779 12.6232 7.24426 12.3068C7.56073 11.9903 7.98995 11.8125 8.4375 11.8125H19.6805C20.0453 11.814 20.4002 11.9323 20.693 12.15L27 16.875L20.693 21.6C20.4002 21.8177 20.0453 21.936 19.6805 21.9375Z"
        fill="#FFAB00"
      />
    </svg>
  </>
);
